const hi = {
  common: {
    loading: "लोड हो रहा है...",
    close: "बंद करें",
    submit: "सबमिट करें",
    review: "रीव्यू",
    help: "सहायता",
    tour: "टूर",
    instructions: "निर्देश",
    language: "भाषा",
    ok: "ठीक है",
    appLoaderText:
      "लोड हो रहा है... कृपया प्रतीक्षा करें जबकि हम आपका असेसमेंट वातावरण तैयार कर रहे हैं।"
  },
  assessment: {
    fetchError: "{{featureName}} लोड करने में त्रुटि",
    somethingWentWrong: "कुछ गलत हो गया।",
    goBackToDashboard: "डैशबोर्ड पर वापस जाएं",
    confirmSubmissionTitle: "सबमिशन की पुष्टि करें",
    scheduleIdNotFound: "Schedule Id नहीं मिला",
    ongoingIdNotFound: "Ongoing Id नहीं मिला",
    errorFetchingOngoingData: "ओनगोइंग डेटा लाने में त्रुटि",
    connectionRestoredLabel: "कनेक्शन बहाल हो गया।",
    connectionRestoredDescription: "आप टेस्ट केस चलाना जारी रख सकते हैं।",
    connectionLostLabel: "टेस्ट सर्वर से कनेक्शन टूट गया है।",
    connectionLostDescription:
      "अभी आप टेस्ट केस चला या वैलिडेट नहीं कर पाएंगे।",
    featureNames: {
      assessment: "असेसमेंट",
      knowledgeCheck: "नॉलेज चेक"
    },
    cardStatus: {
      na: "लागू नहीं",
      toBeLaunched: "जल्द शुरू होगा",
      expired: "समाप्त",
      expiringSoon: "शीघ्र समाप्त होने वाला",
      ongoing: "प्रगति में"
    },
    cardState: {
      draft: "मसौदा",
      published: "प्रकाशित",
      cancelled: "रद्द",
      inreview: "समीक्षा में",
      readytopublish: "प्रकाशित करने के लिए तैयार",
      sentback: "वापस भेजा गया"
    },
    dashboard: {
      videoProctoring: "वीडियो प्रॉक्टरिंग",
      submitFeature: "{{featureName}} सबमिट करें",
      noSectionsFound: "कोई सेक्शन नहीं मिला",
      expandAllSections: "सभी सेक्शन खोलें",
      closeAllSections: "सभी सेक्शन बंद करें",
      continueShapingAssessments: "अपने असेसमेंट्स को आगे बढ़ाते रहें",
      viewAll: "सभी देखें",
      legend: {
        notStarted: "शुरू नहीं हुआ",
        inProgress: "प्रगति में",
        completed: "पूर्ण"
      }
    },
    confirmModal: {
      description:
        "सबमिट करने के बाद आप अपने {{featureName}} में कोई बदलाव नहीं कर पाएंगे। कृपया पुष्टि से पहले अपने उत्तर देख लें। क्या आप सबमिशन जारी रखना चाहते हैं?",
      lowWordCountWarning:
        "प्रश्न {{questionTitle}} के लिए आपका उत्तर 40 शब्दों से कम है। अभी सबमिट करने पर यह उत्तर सेव नहीं होगा।",
      videoNotSubmittedWarning:
        "प्रश्न {{questionTitle}} के लिए आपका रिकॉर्ड किया गया वीडियो सबमिट नहीं हुआ है। अभी सबमिट करने पर यह उत्तर हट जाएगा।",
      unansweredQuestions: "आपके {{count}} प्रश्न अनुत्तरित हैं",
      andFlaggedQuestions: "और {{count}} प्रश्न फ्लैग किए गए हैं",
      failedToFinish: "{{featureName}} पूरा करने में विफल"
    },
    feedback: {
      submittedTitle: "आपका {{featureName}} सफलतापूर्वक सबमिट हो गया!",
      submittedDescription:
        "आपके उत्तर सबमिट हो गए हैं। इस {{featureName}} को पूरा करने में लगाए गए समय और मेहनत की सराहना करते हैं!",
      resultInProgress:
        "परिणाम की गणना हो रही है, इसमें एक मिनट तक का समय लग सकता है। कृपया प्रतीक्षा करें...",
      resultReady:
        "परिणाम तैयार है! देखने के लिए परिणाम दिखाएं बटन पर क्लिक करें।",
      resultDelayed:
        "परिणाम गणना में सामान्य से अधिक समय लग रहा है। कृपया अपने परिणाम के लिए एडमिन से संपर्क करें।",
      showResult: "परिणाम दिखाएं",
      redirectingToResult:
        "{{seconds}} सेकंड में परिणाम पृष्ठ पर पुनर्निर्देशित हो रहे हैं, यदि आप परिणाम दिखाएं बटन पर क्लिक नहीं करते",
      shareFeedbackTitle: "अपनी प्रतिक्रिया साझा करें",
      shareFeedbackDescription:
        "आपकी जानकारी विकास का मार्ग प्रशस्त करती है। आइए मिलकर आगे बढ़ें!",
      errorSubmittingFeedback: "प्रतिक्रिया सबमिट करने में त्रुटि",
      feedbackSubmittedTitle: "सब ठीक है, प्रतिक्रिया सबमिट हो गई!",
      feedbackSubmittedDescription:
        "आपकी प्रतिक्रिया सबमिट हो गई है। {{featureName}} अनुभव बेहतर बनाने में मदद के लिए धन्यवाद!",
      feedbackAlreadySubmittedTitle:
        "सब ठीक है, प्रतिक्रिया पहले ही सबमिट हो चुकी है!",
      feedbackAlreadySubmittedDescription:
        "लगता है आपने पहले ही प्रतिक्रिया सबमिट कर दी है। {{featureName}} अनुभव बेहतर बनाने में मदद के लिए धन्यवाद!"
    },
    page: {
      errorFetchingPreAssessmentData: "प्री-असेसमेंट डेटा लाने में त्रुटि",
      connectionRestoredLabel: "कनेक्शन बहाल हो गया।",
      connectionRestoredDescription: "आपके नवीनतम बदलाव सिंक हो रहे हैं...",
      offlineLabel: "लगता है आप ऑफलाइन हैं।",
      offlineDescription: "दोबारा कनेक्ट होने तक बदलाव सिंक नहीं होंगे"
    },
    question: {
      questions: "प्रश्न",
      closeQuestionsPanel: "प्रश्न पैनल बंद करें",
      collapse: "संकुचित करें",
      sectionSummary: "सेक्शन सारांश",
      sections: "सेक्शन",
      toggleQuestionsPanel: "प्रश्न पैनल टॉगल करें",
      switchModal: {
        switchQuestionButton: "प्रश्न बदलें",
        leaveHeading: "क्या आप वाकई बाहर जाना चाहते हैं?",
        discardMessage:
          "आपके बदलाव सहेजे नहीं गए हैं। यदि आप प्रश्न बदलते हैं, तो आपका उत्तर स्थायी रूप से हट जाएगा।",
        saveChangesButton: "बदलाव सहेजें",
        saveHeading: "क्या आप बदलाव सहेजना चाहते हैं?",
        saveBeforeSwitchMessage:
          "आपके बदलाव सहेजे नहीं गए हैं। क्या आप प्रश्न बदलने से पहले इन्हें सहेजना चाहेंगे?"
      }
    },
    faq: {
      q1: {
        question: "{{featureName}} शुरू करने से पहले मुझे क्या करना चाहिए?",
        firstSentence:
          "कृपया सुनिश्चित करें कि आपने ये तैयारियां पूरी कर ली हैं:",
        list: {
          item1: "स्थिर इंटरनेट कनेक्शन",
          item2:
            "काम करने वाला वेबकैम और माइक्रोफोन (यदि वीडियो प्रॉक्टरिंग सक्षम है)",
          item3: "शांत और बिना व्यवधान वाला वातावरण",
          item4:
            "यदि वीडियो प्रॉक्टरिंग सक्षम है, तो आपको सिस्टम जांच पूरी करने के लिए कहा जाएगा।",
          item5: "नियम और शर्तें पढ़ें और सहमति दें"
        }
      },
      q2: {
        question:
          "क्या मैं {{featureName}} के दौरान प्रश्नों या सेक्शनों के बीच जा सकता/सकती हूं?",
        firstSentence: "नेविगेशन सेटिंग्स पर निर्भर करता है।",
        list: {
          item1:
            "यदि सेक्शन नेविगेशन सक्षम है, तो आप सेक्शनों के बीच जा सकते हैं।",
          item2:
            "यदि यह अक्षम है, तो अगले सेक्शन में जाने से पहले आपको एक सेक्शन पूरा करना होगा।"
        },
        lastSentence:
          "निर्देश पूरे {{featureName}} के दौरान हमेशा उपलब्ध रहेंगे।"
      },
      q3: {
        question: "क्या टेस्ट के दौरान मेरी निगरानी की जाएगी?",
        list: {
          item1:
            "यदि इस {{featureName}} में वीडियो प्रॉक्टरिंग सक्षम है, तो आपका कैमरा और माइक्रोफोन उपयोग किए जाएंगे।",
          item2:
            "किसी भी असामान्य गतिविधि को समीक्षा के लिए चिन्हित किया जा सकता है।"
        }
      },
      q4: {
        question:
          "अगर इंटरनेट कनेक्शन चला जाए या ब्राउज़र गलती से बंद हो जाए तो क्या होगा?",
        firstSentence: "आपकी प्रगति स्वतः सेव होती रहती है।",
        lastSentence:
          "डिस्कनेक्शन होने पर आप उसी लिंक से {{featureName}} में दोबारा जुड़ सकते हैं।"
      },
      q5: {
        question: "क्या टेस्ट के बाद मुझे अपना परिणाम या फीडबैक दिखेगा?",
        firstSentence:
          "परिणाम और फीडबैक की उपलब्धता {{featureName}} आयोजक द्वारा निर्धारित की जाती है।",
        list: {
          item1:
            "यदि सक्षम है, तो सबमिशन के बाद आपको अपना स्कोर और फीडबैक सारांश दिखाई देगा।",
          item2:
            "यदि सक्षम नहीं है, तो आपके परिणाम आपके पंजीकृत ईमेल पर साझा किए जाएंगे।"
        }
      }
    },
    labels: {
      totalDuration: "कुल अवधि",
      numberOfQuestions: "प्रश्नों की संख्या",
      numberOfSections: "सेक्शनों की संख्या",
      guidelines: "दिशानिर्देश",
      platformHelp: "प्लेटफॉर्म सहायता",
      faq: "सामान्य प्रश्न",
      frequentlyAskedQuestions: "अक्सर पूछे जाने वाले प्रश्न",
      showFeatureInstructions: "{{featureName}} निर्देश दिखाएं",
      minutes: "मिनट",
      welcome: "स्वागत है",
      welcomeBack: "वापस आपका स्वागत है",
      userFallback: "उपयोगकर्ता",
      defaultGuidelines:
        "{{featureName}} शुरू करने से पहले सुनिश्चित करें कि आप शांत, बाधारहित जगह पर हैं और स्थिर इंटरनेट कनेक्शन है। पूरे परीक्षण के दौरान कैमरा चालू रखें और समय सीमा का ध्यान रखें। किसी तकनीकी समस्या पर तुरंत सपोर्ट से संपर्क करें। सबमिट करने से पहले अपने उत्तर जांचें। शुभकामनाएं!"
    },
    zoom: {
      textSize: "टेक्स्ट आकार:",
      decreaseTextSize: "टेक्स्ट आकार घटाएं (A-)",
      resetTextSize: "टेक्स्ट आकार रीसेट करें (A)",
      increaseTextSize: "टेक्स्ट आकार बढ़ाएं (A+)",
      decreaseInterfaceSize: "इंटरफेस आकार घटाएं",
      resetInterfaceSize: "इंटरफेस आकार रीसेट करें",
      increaseInterfaceSize: "इंटरफेस आकार बढ़ाएं"
    },
    wrapper: {
      warningTitle: "चेतावनी!",
      stayOnPageMessage: "कृपया {{featureName}} पूरा होने तक इस पृष्ठ पर रहें।",
      iUnderstand: "मैं समझ गया",
      submitTheFeature: "{{featureName}} सबमिट करें",
      videoProctoringInterrupted: "वीडियो प्रॉक्टरिंग बाधित हुई",
      continuationBlocked:
        "सुरक्षित वीडियो प्रॉक्टरिंग बहाल होने तक असेसमेंट जारी रखना संभव नहीं है।",
      retryProctoring: "प्रॉक्टरिंग पुनः प्रयास करें"
    },
    progress: {
      proceed: "आगे बढ़ें",
      resumeFeature: "{{featureName}} फिर से शुरू करें",
      timeRemainingMessage:
        "{{featureName}} में शेष समय। जहाँ छोड़ा था वहाँ से जारी रखने के लिए नीचे क्लिक करें।",
      continueOnThisDevice: "इस डिवाइस पर जारी रखें?",
      switchToThisTab: "इस टैब पर स्विच करें?",
      continueYourAssessmentHere: "यहाँ अपना असेसमेंट जारी रखें?",
      switchHere: "यहाँ स्विच करें",
      attemptsUnlimited:
        "इस असेसमेंट के लिए आपके पास असीमित प्रयास उपलब्ध हैं।",
      attemptsSingle:
        "इस असेसमेंट के लिए आपके पास <strong>1</strong> प्रयास उपलब्ध है।",
      attemptsMultiple:
        "इस असेसमेंट के लिए आपके पास <strong>{{maxAttempts}}</strong> में से <strong>{{remainingAttempts}}</strong> प्रयास उपलब्ध हैं।",
      coolOffAfterAttempt:
        "प्रत्येक प्रयास के बाद, आप अपना अगला प्रयास शुरू करने से पहले <strong>{{coolOffTime}}</strong> प्रतीक्षा करेंगे।"
    },
    loginWindow: {
      expiredTitle: "लॉगिन समय समाप्त",
      expiredMessage:
        "इस {{featureName}} के लिए लॉगिन विंडो अब बंद हो गई है। परीक्षण तक पहुंचने का अनुमत समय बीत गया।"
    },
    coding: {
      saving: "सेव हो रहा है",
      offlineTitle: "लगता है आप ऑफलाइन हैं",
      offlineDescription: "दोबारा कनेक्ट होने तक बदलाव सिंक नहीं होंगे",
      connectionRestored: "कनेक्शन बहाल हो गया",
      syncingLatest: "आपके नवीनतम बदलाव सिंक हो रहे हैं...",
      autoSaveEnabled: "ऑटो सेव चालू है",
      runOnlyChecksDescription:
        "केवल आपके कोड को टेस्ट केस के खिलाफ जांचता है।",
      submitEvaluationDescription:
        "अपने कोड का मूल्यांकन कराने और अंक प्राप्त करने के लिए।",
      reset: "रीसेट",
      run: "चलाएं",
      runTests: "टेस्ट चल रहे हैं",
      submit: "सबमिट करें",
      submitting: "सबमिट हो रहा है",
      resetCode: "कोड रीसेट करें",
      resetCodeMessage:
        "क्या आप वाकई रीसेट करना चाहते हैं? यह आपका सभी मौजूदा कोड हटा देगा और स्टार्टर कोड वापस लाएगा",
      testCases: "टेस्ट केस",
      testCase: "टेस्ट केस {{index}}",
      testCasePassed: "टेस्ट केस पास हुआ",
      testCaseFailed: "टेस्ट केस फेल हुआ",
      runtimeError: "रनटाइम त्रुटि",
      timeLimitExceeded: "समय सीमा पार हुई",
      timeLimitExceededTitle: "समय सीमा पार हो गई",
      timeLimitExceededDescription:
        "आपका कोड समय सीमा में नहीं चला। कृपया कोड अनुकूलित करें।",
      input: "इनपुट",
      expectedOutput: "अपेक्षित आउटपुट",
      yourOutput: "आपका आउटपुट",
      hiddenTestCase: "छिपा टेस्ट केस",
      hiddenTestCaseDescription:
        "छिपे टेस्ट केस यह मूल्यांकन करने के लिए उपयोग किए जाते हैं कि आपका कोड कोने के मामलों सहित विभिन्न परिदृश्यों को संभाल सकता है या नहीं",
      explanation: "व्याख्या",
      hints: "संकेत"
    },
    subjective: {
      minWordsRequired: "उत्तर सबमिट करने के लिए न्यूनतम 40 शब्द आवश्यक हैं।",
      enterYourAnswer: "अपना उत्तर दर्ज करें",
      submitResponse: "उत्तर सबमिट करें",
      submittingResponse: "उत्तर सबमिट हो रहा है...",
      resetAnswer: "उत्तर रीसेट करें",
      resetAnswerMessage:
        "क्या आप वाकई रीसेट करना चाहते हैं? आपका मौजूदा उत्तर स्थायी रूप से हट जाएगा।",
      retake: "दोबारा लें",
      showHint: "संकेत दिखाएं",
      recording: "रिकॉर्डिंग"
    },
    systemCheck: {
      calibrate: "कैलिब्रेट करें",
      calibrating: "कैलिब्रेट हो रहा है...",
      accessDenied: "पहुंच अस्वीकृत",
      cameraPermissionDenied:
        "कैमरा के लिए अनुमति अस्वीकार कर दी गई है। जारी रखने के लिए कृपया अपने ब्राउज़र सेटिंग्स में कैमरा एक्सेस सक्षम करें।",
      errorFetchingDevices: "डिवाइस प्राप्त करने में त्रुटि",
      failedToStartAssessment: "असेसमेंट शुरू करने में विफल",
      unableToStartSecureProctoring:
        "सुरक्षित प्रॉक्टरिंग अभी शुरू नहीं हो सकी। कृपया पुनः प्रयास करें।",
      unnamedCamera: "अज्ञात कैमरा",
      facingCalibrationIssues: "वीडियो कैलिब्रेशन में समस्या आ रही है?",
      lookAtCenter: "कृपया स्क्रीन के केंद्र में देखें और स्थिर रहें।",
      unableToCalibrateTitle:
        "वीडियो प्रॉक्टरिंग के लिए कैमरा कैलिब्रेट नहीं हो पा रहा?",
      statusMessages: {
        readyForCalibration:
          "सुनिश्चित करें कि आपका चेहरा स्पष्ट रूप से दिखाई दे रहा हो और स्क्रीन के केंद्र में हो। तैयार होने पर शुरू करने के लिए 'कैलिब्रेट' पर क्लिक करें।",
        calibratingInProgress:
          "कैलिब्रेशन चल रहा है। स्क्रीन की ओर देखते रहें।",
        calibratingTimedOut:
          "कैमरा कैलिब्रेशन का समय समाप्त हो गया। जारी रखने के लिए कृपया अपना ब्राउज़र रीफ्रेश करें।",
        preparingCameraPreview:
          "कैलिब्रेशन के लिए कैमरा स्ट्रीम और फेस ट्रैकिंग तैयार की जा रही है।",
        retryRequired:
          "आगे बढ़ने से पहले प्रॉक्टरिंग सेटअप में आपकी कार्रवाई आवश्यक है।",
        proctoringUnavailable:
          "प्रॉक्टरिंग फिलहाल उपलब्ध नहीं है और असेसमेंट सुरक्षित रूप से शुरू नहीं किया जा सकता।",
        calibrationCompleted:
          "कैलिब्रेशन सफल रहा! आप असेसमेंट शुरू करने के लिए तैयार हैं।",
        timeoutHelp:
          "यदि यह संदेश अभी भी दिख रहा है, तो कैमरा उपयोग कर रहे अन्य टैब/ऐप या बाहरी शटर की जांच करें।"
      },
      failureReasons: {
        cameraPermissionDenied:
          "कैमरा अनुमति अवरुद्ध है। एक्सेस दें और पुनः प्रयास करें।",
        cameraUnavailable:
          "कैमरा उपलब्ध नहीं है। अपना डिवाइस चयन जांचें और पुनः प्रयास करें।",
        facemeshInitFailed:
          "फेस ट्रैकिंग सेटअप विफल हुआ। जारी रखने के लिए पुनः प्रयास करें।",
        cocoLoadFailed:
          "प्रॉक्टरिंग इंजन उपलब्ध नहीं है। रीफ्रेश करें और फिर से प्रयास करें।",
        streamLostReacquireFailed:
          "कैमरा स्ट्रीम पुनर्प्राप्ति विफल हुई। प्रॉक्टरिंग पुनः प्रयास करें।",
        calibrationInsufficientData:
          "कैलिब्रेशन सैंपल पर्याप्त नहीं थे। कैलिब्रेशन पुनः प्रयास करें।",
        detectionCadenceUnavailable:
          "टाइमिंग कॉन्फ़िगरेशन तैयार नहीं है। थोड़ी देर बाद पुनः प्रयास करें।"
      },
      calibrationInfo: {
        heading:
          "अपने वीडियो को सफलतापूर्वक कैलिब्रेट करने के लिए, कृपया इन चरणों का पालन करें:",
        followUpHeading: "यदि समस्या फिर भी बनी रहे, तो इन चरणों का पालन करें:",
        initialSteps: {
          step1: {
            title: "अच्छी रोशनी सुनिश्चित करें",
            description:
              "ऐसी जगह बैठें जहां पर्याप्त रोशनी हो और आपका चेहरा स्पष्ट दिखाई दे। अपने पीछे तेज रोशनी या खिड़कियां न रखें।"
          },
          step2: {
            title: "कैमरे की ओर सीधे देखें",
            description:
              "कैलिब्रेशन के दौरान अपना चेहरा फ्रेम के केंद्र में रखें और सीधे कैमरे की ओर देखें।"
          },
          step3: {
            title: "बहुत गहरे या धुंधले बैकग्राउंड से बचें",
            description:
              "सुनिश्चित करें कि आपका बैकग्राउंड साफ हो और बहुत अंधेरा न हो।"
          },
          step4: {
            title: "कैमरा अनुमतियां जांचें",
            description:
              "प्रॉम्प्ट आने पर ब्राउज़र को वेबकैम एक्सेस की अनुमति दें।"
          },
          step5: {
            title: "स्थिर रहें और स्क्रीन देखें",
            description:
              "कैलिब्रेशन के दौरान सिर स्थिर रखें ताकि सिस्टम आपका चेहरा सही तरीके से पहचान सके।"
          }
        },
        laterSteps: {
          step1:
            "पेज को रीफ्रेश करके कैमरा दोबारा कैलिब्रेट करने का प्रयास करें।",
          step2:
            "वेबकैम का उपयोग करने वाले अन्य ऐप (जैसे Zoom या Teams) बंद करें।",
          step3:
            "यदि समस्या जारी रहे, तो त्रुटि के स्क्रीनशॉट के साथ {{contactEmail}} पर संपर्क करें।"
        }
      }
    },
    stepper: {
      termsAndConditions: "नियम एवं शर्तें",
      agreeTerms: "मैंने नियम एवं शर्तें पढ़ लिए हैं और सहमत हूं।",
      previousStep: "पिछला चरण",
      nextStep: "अगला चरण",
      startAssessment: "असेसमेंट शुरू करें",
      resumeAssessment: "असेसमेंट फिर से शुरू करें",
      mediaCheck: "मीडिया जांच",
      systemCheck: "सिस्टम जांच",
      audioCheck: {
        intro:
          "आप यहां एक छोटा वीडियो रिकॉर्ड कर सकते हैं ताकि यह जांच सकें कि आपका कैमरा और माइक्रोफोन सही तरीके से काम कर रहे हैं",
        mediaPermissionDenied:
          "कैमरा या माइक्रोफोन की अनुमति अस्वीकार कर दी गई है। कृपया अपने ब्राउज़र सेटिंग्स में अनुमति सक्षम करें।",
        startRecording: "रिकॉर्डिंग शुरू करें",
        stopRecording: "रिकॉर्डिंग रोकें",
        unnamedMicrophone: "अज्ञात माइक्रोफोन"
      },
      stepLabel: "चरण {{step}}",
      personalDetails: "व्यक्तिगत विवरण",
      emailId: "ईमेल आईडी",
      firstName: "पहला नाम",
      lastName: "अंतिम नाम",
      defaultTncStatement:
        "इस असेसमेंट में भाग लेकर आप पुष्टि करते हैं कि आप कंपनी द्वारा निर्धारित पात्रता आवश्यकताओं को पूरा करते हैं और बिना किसी बाहरी सहायता के टेस्ट स्वतंत्र रूप से पूरा करेंगे। यह असेसमेंट वीडियो प्रॉक्टरिंग के अधीन है, और पूरे सत्र के दौरान आपका कैमरा चालू होना चाहिए तथा आप बाधारहित वातावरण में हों। असेसमेंट के दौरान प्रदान की गई सभी सामग्री गोपनीय है और इसे साझा, पुनरुत्पादित या वितरित नहीं किया जाना चाहिए। आप असेसमेंट की निर्धारित समय सीमा का पालन करने के लिए सहमत हैं; समय सीमा से पहले सबमिट न करने पर अयोग्यता हो सकती है। आपकी इंटरनेट कनेक्टिविटी, सॉफ्टवेयर या हार्डवेयर से संबंधित तकनीकी समस्याओं के लिए कंपनी उत्तरदायी नहीं होगी। असेसमेंट के दौरान एकत्रित व्यक्तिगत डेटा का उपयोग केवल मूल्यांकन और भर्ती उद्देश्यों के लिए, कंपनी की गोपनीयता नीति के अनुसार किया जाएगा। नकल, साहित्यिक चोरी या किसी भी अन्य अनैतिक व्यवहार का प्रयास तत्काल अयोग्यता का कारण बनेगा। अपने उत्तर सबमिट करके आप पुष्टि करते हैं कि वे अंतिम हैं और सबमिशन के बाद उनमें कोई संशोधन नहीं किया जा सकता। कंपनी को किसी भी समय इन शर्तों में संशोधन या अद्यतन करने का अधिकार सुरक्षित है, और महत्वपूर्ण परिवर्तनों की सूचना प्रतिभागियों को दी जाएगी।",
      okay: "ठीक है"
    },
    access: {
      cancelledTitle: '"{{title}}" रद्द कर दिया गया है',
      cancelledDescription:
        "यह असेसमेंट अब सक्रिय नहीं है और एक्सेस नहीं किया जा सकता। कृपया अन्य असाइन किए गए या आगामी असेसमेंट के लिए डैशबोर्ड देखें।",
      goToHome: "होम पर जाएं",
      refreshPage: "पृष्ठ रीफ्रेश करें"
    },
    errorPage: {
      goBack: "वापस जाएं",
      raiseRequest: "अनुरोध उठाएं",
      retryLogin: "फिर से लॉगिन करें",
      contactUs: "संपर्क करें",
      goBackToEvent: "इवेंट पर वापस जाएं",
      launchCourse: "कोर्स लॉन्च करें",
      created: "बनाया गया",
      starts: "शुरू होता है",
      ends: "समाप्त होता है",
      untitled: "बिना शीर्षक"
    },
    sidebar: {
      home: "होम",
      quickAccess: "त्वरित पहुंच",
      questionPaperAuthoring: "प्रश्नपत्र लेखन",
      assessmentLibrary: "असेसमेंट लाइब्रेरी",
      scheduleInterview: "इंटरव्यू शेड्यूल करें",
      generateQuestions: "प्रश्न जनरेट करें",
      roleManagement: "भूमिका प्रबंधन",
      logout: "लॉगआउट",
      noAccess: "पहुंच नहीं",
      noAccessWithLabel: "{{label}} (पहुंच नहीं)",
      noAccessToLink: "आपके पास इस लिंक तक पहुंच नहीं है",
      expandSidebar: "साइडबार फैलाएं",
      collapseSidebar: "साइडबार समेटें",
      expand: "फैलाएं",
      collapse: "समेटें",
      myPreferences: "मेरी प्राथमिकताएँ"
    },
    timesUp: {
      title: "असेसमेंट का समय पूरा हुआ",
      autoSubmittedMessage:
        "समय समाप्त हो गया। आपके उत्तर सेव हो गए हैं और {{featureName}} स्वचालित रूप से सबमिट हो गया।"
    },
    resultCard: {
      title: "{{featureName}} परिणाम",
      score: "स्कोर",
      passPercentage: "पास प्रतिशत",
      marksAway:
        "आप प्रमाणन से {{count}} अंक दूर हैं। अनुशंसित क्षेत्रों पर ध्यान दें और पुनः प्रयास करें।",
      certificationEarned:
        "आपने प्रमाणन आवश्यकताओं को पार किया और प्रमाणन अर्जित किया",
      congratulationsOnEarning: "{{featureName}} प्रमाणन अर्जित करने पर बधाई",
      almostThereTitle: "आप प्रमाणन पाने के बहुत करीब हैं",
      certificatePassedDescription:
        "आपने इस प्रमाणन के लिए आवश्यक ज्ञान और कौशल प्रदर्शित किए हैं। इस उपलब्धि का जश्न मनाएं और इसे अपने नेटवर्क के साथ साझा करें।",
      certificateFailDescription:
        "इस प्रयास से आपकी कौशल-वृद्धि के अवसर स्पष्ट हुए हैं। सुझाए गए क्षेत्रों की समीक्षा करें और आत्मविश्वास के साथ लौटें।",
      congratsImageAlt: "बधाई चित्र",
      almostThereImageAlt: "लगभग पहुंच गए चित्र"
    },
    sectionCard: {
      section: "सेक्शन",
      startSection: "सेक्शन शुरू करें",
      continueSection: "सेक्शन जारी रखें",
      completed: "पूर्ण",
      viewSection: "सेक्शन देखें",
      totalQuestions: "कुल प्रश्न:",
      sectionNotFound: "सेक्शन नहीं मिला।",
      total: "कुल",
      flagged: "फ्लैग्ड"
    },
    sectionSummary: {
      totalQuestions: "कुल प्रश्न",
      completedQuestions: "पूर्ण प्रश्न",
      flaggedQuestions: "फ्लैग किए गए प्रश्न",
      unattemptedQuestions: "अनुत्तरित प्रश्न",
      codingQuestions: "कोडिंग प्रश्न:",
      objectiveQuestions: "वस्तुनिष्ठ प्रश्न:",
      goToSections: "सेक्शन पर जाएं",
      lowWordCountWarning:
        "प्रश्न {{questionTitle}} का आपका उत्तर 40 शब्दों से कम है। सेक्शन सूची पर वापस जाने पर यह उत्तर हट जाएगा।",
      videoNotSubmittedWarning:
        "प्रश्न {{questionTitle}} के लिए आपका रिकॉर्ड किया वीडियो सबमिट नहीं हुआ। सेक्शन सूची पर वापस जाने पर यह उत्तर हट जाएगा।"
    },
    objective: {
      questionCounter: "प्रश्न",
      marks: "अंक :",
      explanation: "व्याख्या",
      hints: "संकेत",
      reset: "रीसेट",
      flag: "फ्लैग",
      unflag: "फ्लैग हटाएं",
      previous: "पिछला",
      saveAndNext: "सेव करें और अगला",
      saveAndViewSummary: "सेव करें और सेक्शन सारांश देखें",
      next: "अगला",
      viewSectionSummary: "सेक्शन सारांश देखें",
      hideExplanation: "व्याख्या छुपाएं",
      showExplanation: "व्याख्या दिखाएं",
      hintWaitTooltip: "अगला संकेत देखने से पहले आपको इंतजार करना होगा",
      noHintsPendingTooltip: "कोई संकेत बाकी नहीं है",
      selectOptionForExplanation:
        "चयनित विकल्प की व्याख्या देखने के लिए विकल्प चुनें"
    },
    tour: {
      shared: {
        timer:
          "यह टाइमर आपके असेसमेंट का शेष समय दिखाता है। कृपया इसे ध्यान से देखें ताकि आप निर्धारित समय में सभी सेक्शन पूरा कर सकें।",
        submit:
          "जब आप असेसमेंट के सभी सेक्शन पूरे कर लें, तो 'असेसमेंट सबमिट करें' बटन पर क्लिक करके अपना कार्य सबमिट कर सकते हैं। इस क्रिया के बाद आपके उत्तर अंतिम हो जाएंगे और सबमिट होने के बाद आप कोई बदलाव नहीं कर पाएंगे। सबमिट करने से पहले अपने सभी उत्तर अवश्य जांच लें।"
      },
      dashboard: {
        legend:
          "सेक्शन स्टेटस लेजेंड आपको पूरे असेसमेंट में अपनी प्रगति समझने में मदद करता है। यह स्पष्ट संकेत देता है कि कोई सेक्शन शुरू नहीं हुआ है, प्रगति में है, या पूरा हो चुका है। इससे आप जल्दी पहचान सकते हैं कि किन हिस्सों पर अभी ध्यान देना है और समय का बेहतर प्रबंधन कर सकते हैं।",
        sectionCard:
          "सेक्शन कार्ड हर असेसमेंट सेक्शन का विस्तृत अवलोकन देता है। इसमें सेक्शन का शीर्षक, उसकी वर्तमान स्थिति, और प्रश्नों से जुड़ी मुख्य जानकारी दिखाई जाती है। इसमें कुल प्रश्नों की संख्या, फ्लैग किए गए प्रश्नों की संख्या, और पूरे किए गए प्रश्नों की संख्या शामिल है। सेक्शन कार्ड आपकी प्रगति ट्रैक करने और अधिक ध्यान देने वाले क्षेत्रों की पहचान करने में मदद करता है।"
      },
      coding: {
        titles:
          "पेज के शीर्ष पर आपको असेसमेंट शीर्षक और सेक्शन शीर्षक स्पष्ट रूप से दिखाई देंगे। इससे आप अपने वर्तमान कार्य पर केंद्रित रह पाते हैं और जान पाते हैं कि आप किस सेक्शन पर काम कर रहे हैं। प्रश्नों के बीच नेविगेट करते समय दिशा बनाए रखने के लिए इन शीर्षकों का उपयोग करें।",
        sectionsButton:
          "यह बटन आपको आसानी से सेक्शंस डैशबोर्ड पर वापस ले जाता है। इसका उपयोग करके आप असेसमेंट के मुख्य ओवरव्यू पर लौट सकते हैं, जहां आप सभी सेक्शनों की प्रगति देख और प्रबंधित कर सकते हैं। इससे आपका वर्तमान काम खोए बिना समग्र प्रगति का त्वरित आकलन संभव होता है।",
        sidebar:
          "साइडबार उस वर्तमान सेक्शन के सभी प्रश्नों का ओवरव्यू देता है जिसे आप हल कर रहे हैं। आप संबंधित ब्लॉक चुनकर प्रश्नों के बीच जल्दी नेविगेट कर सकते हैं। हर प्रश्न ब्लॉक स्टेटस के आधार पर रंग-कोडेड है, जिससे प्रगति ट्रैक करना और जरूरत के अनुसार विशिष्ट प्रश्नों पर जाना आसान होता है।",
        questionCard:
          "यह कार्ड उस प्रश्न को दिखाता है जिस पर आप अभी काम कर रहे हैं, जिसमें पूरा प्रॉम्प्ट और आवश्यक निर्देश या इनपुट आवश्यकताएं शामिल होती हैं। इसे इस तरह डिजाइन किया गया है कि आपको कार्य की स्पष्ट समझ मिले और आगे बढ़ने के लिए सभी जरूरी जानकारी एक ही जगह मिले। यहां प्रश्न को बाद में समीक्षा के लिए फ्लैग करने का विकल्प भी है। साथ ही, बिना साइडबार पर लौटे अगले या पिछले प्रश्न पर जाने के लिए नेविगेशन बटन भी दिए गए हैं, जिससे आपका प्रवाह सुचारू बना रहता है।",
        editor:
          "कोड एडिटर वह जगह है जहां आप अपने समाधान लिखते और संशोधित करते हैं। हर प्रश्न की आवश्यकता के अनुसार आप अलग-अलग प्रोग्रामिंग भाषाओं में स्विच कर सकते हैं। अधिक आरामदायक अनुभव के लिए एडिटर थीम बदलने का विकल्प भी उपलब्ध है। यदि आपको अधिक कार्य-क्षेत्र चाहिए, तो एडिटर को फुल-विड्थ में विस्तारित किया जा सकता है। ये सुविधाएं आपको कोडिंग कार्यों के दौरान एक लचीला और उपयोगकर्ता-अनुकूल वातावरण प्रदान करती हैं।"
      }
    },
    toast: {
      proctoringViolationDetected: "प्रॉक्टरिंग उल्लंघन पाया गया",
      messages: {
        forbiddenObjectDetected: "प्रतिबंधित वस्तु पाई गई",
        noFaceDetected: "कोई चेहरा नहीं मिला",
        multipleFacesDetected: "एक से अधिक चेहरे पाए गए",
        lookingAwayFromScreen: "स्क्रीन से नज़र हटाई गई",
        notLookingAtScreen: "स्क्रीन की ओर नहीं देख रहे हैं",
        faceNotOrientedCorrectly: "चेहरे की दिशा सही नहीं है",
        eyesNotFullyOpen: "आंखें पूरी तरह खुली नहीं हैं",
        copyNotAllowed: "कॉपी करना अनुमत नहीं है",
        cutRestricted: "प्रॉक्टरिंग मोड में कट करना प्रतिबंधित है",
        pasteNotAllowed: "पेस्ट करना अनुमत नहीं है",
        contextMenuNotAllowed: "कॉन्टेक्स्ट मेनू खोलना अनुमत नहीं है"
      }
    },
    whatsNext: {
      heading: "आगे क्या?",
      attemptsRemaining: "प्रयास शेष",
      passed: {
        shareLinkedInTitle: "LinkedIn पर साझा करें",
        shareLinkedInSubtitle:
          "अपनी उपलब्धि को अपने प्रोफेशनल नेटवर्क के साथ साझा करें।",
        viewCertificateTitle: "प्रमाणपत्र देखें",
        viewCertificateSubtitle:
          "कभी भी अपना प्रमाणपत्र डाउनलोड करें या एक्सेस करें।",
        shareGloTitle: "अनुभव साझा करें",
        shareGloSubtitle:
          "अपनी उपलब्धि आंतरिक रूप से पोस्ट करके सहकर्मियों को प्रेरित करें।"
      },
      failed: {
        reviewLearningResourcesTitle: "लर्निंग संसाधनों की समीक्षा करें",
        reviewLearningResourcesSubtitle:
          "जिस कौशल पर ध्यान चाहिए, उसे मजबूत करें।",
        retakeAssessmentTitle: "असेसमेंट दोबारा दें",
        retakeAssessmentSubtitle: "अपनी प्रगति और बेहतर समझ प्रदर्शित करें।"
      },
      modal: {
        title: "उपलब्धि साझा करें",
        linkedInPostLabel: "LinkedIn पोस्ट के रूप में साझा करें",
        linkedInProfileLabel:
          "LinkedIn प्रोफ़ाइल में प्रमाणपत्र के रूप में जोड़ें",
        gloLabel: "Glo पर साझा करें",
        comingSoon: "जल्द आ रहा है",
        infoMessage:
          "साझा करने के लिए आपको प्लेटफ़ॉर्म में लॉग इन होना आवश्यक है।"
      }
    },
    time: {
      hour_one: "{{count}} घंटा",
      hour_other: "{{count}} घंटे",
      minute_one: "{{count}} मिनट",
      minute_other: "{{count}} मिनट",
      hourShort: "घं",
      minuteShort: "मि",
      secondShort: "से"
    },
    accessScreens: {
      attemptResultProcessing: {
        alt: "{{featureName}} परिणाम संसाधित किए जा रहे हैं",
        title: "आपके परिणाम संसाधित किए जा रहे हैं",
        description:
          "हम अभी भी आपके {{featureName}} की समीक्षा कर रहे हैं। कृपया थोड़ी देर बाद फिर जांचें!"
      },
      coolOffPeriod: {
        alt: "कूल ऑफ अवधि",
        title: "अगला प्रयास जल्द उपलब्ध होगा",
        completedAttempt: "आप इस",
        nextAttemptIntro:
          "के लिए एक प्रयास पहले ही पूरा कर चुके हैं। आपका अगला प्रयास"
      },
      maxAttemptExceeded: {
        alt: "अधिकतम प्रयास पूरे हुए",
        title: "अधिकतम प्रयास पूरे हो गए",
        description:
          "आपने इस {{featureName}} के लिए सभी उपलब्ध प्रयासों का उपयोग कर लिया है। अब आगे प्रयास नहीं किया जा सकता।"
      },
      scheduleNotStarted: {
        alt: "शेड्यूल शुरू नहीं हुआ",
        title: "{{featureName}} अभी शुरू नहीं हुआ है",
        scheduledPrefix: "",
        scheduledOn: "का प्रारंभ समय",
        checkBack:
          "कृपया {{time}} बाद वापस आएं या समय शुरू होते ही रिफ्रेश करें।"
      },
      scheduleTimeCompleted: {
        alt: "निर्धारित समय समाप्त",
        title: "{{featureName}} विंडो बंद हो गई",
        description:
          "इस {{featureName}} का निर्धारित समय समाप्त हो चुका है। अब आप प्रयास शुरू या सबमिट नहीं कर सकते।"
      }
    },
    attemptDetails: {
      allAttempts: "सभी प्रयास",
      headers: {
        attempt: "प्रयास",
        attemptedOn: "प्रयास की तारीख",
        percentage: "प्रतिशत"
      },
      viewAllAttempts: "सभी प्रयास देखें"
    },
    survey: {
      questions: {
        q1: "1 से 5 के पैमाने पर, आपको {{featureName}} के प्रश्न कितने स्पष्ट लगे?",
        q2: "मुझे लगा कि मैं {{featureName}} में शामिल विषयों के लिए पर्याप्त रूप से तैयार था/थी",
        q3: "{{featureName}} के लिए उपयोग किया गया प्लेटफॉर्म उपयोग में आसान और कार्यात्मक था",
        q4: "मेरा मानना है कि मेरे उत्तरों ने मेरी कौशल और ज्ञान को प्रभावी रूप से प्रदर्शित किया"
      },
      stronglyDisagree: "पूर्णतः असहमत",
      stronglyAgree: "पूर्णतः सहमत",
      submitFeedback: "प्रतिक्रिया सबमिट करें"
    },
    cameraPreview: {
      loadingAlt: "कैमरा प्रीव्यू लोड हो रहा है",
      delayedMessage:
        "धीमे नेटवर्क के कारण कैलिब्रेशन में अपेक्षा से अधिक समय लग रहा है। कृपया प्रतीक्षा करें या पेज रिफ्रेश करें।"
    },
    proctoring: {
      engineLoadFailedStatus: "प्रॉक्टरिंग इंजन लोड नहीं हो सका",
      runtimeErrors: {
        cameraPermissionDenied:
          "ब्राउज़र अनुमति सेटिंग के कारण कैमरा एक्सेस अवरुद्ध है।",
        cameraUnavailable:
          "कैमरा उपलब्ध नहीं है या किसी अन्य एप्लिकेशन द्वारा उपयोग में है।",
        unableToLoadModel:
          "प्रॉक्टरिंग ऑब्जेक्ट-डिटेक्शन मॉडल लोड नहीं हो सका।",
        webglRecoveryFailed:
          "ऑब्जेक्ट डिटेक्शन बहाल करते समय WebGL रिकवरी विफल रही।"
      },
      logs: {
        engineLoadFailed: "ProctoringEngine लोड नहीं हो सका:",
        videoPlayRejected: "Video play() अस्वीकार हुआ:",
        cameraTrackEnded: "कैमरा ट्रैक समाप्त - पुनः प्राप्ति का प्रयास जारी",
        cameraReacquired: "कैमरा प्रयास {{attempt}} में फिर से प्राप्त हुआ",
        cameraReacquireAttemptFailed:
          "कैमरा पुनः प्राप्ति प्रयास {{attempt}} विफल हुआ:",
        cameraReacquireFailedAll:
          "सभी प्रयासों के बाद कैमरा पुनः प्राप्त नहीं हो सका - हर चक्र में cameraDisconnected रिपोर्ट किया जाएगा",
        uploadFailedQueued:
          "प्रॉक्टरिंग अपलोड {{attempts}} प्रयासों के बाद विफल हुआ, पुनः प्रयास हेतु कतार में जोड़ा जा रहा है:",
        uploadAttemptFailedRetrying:
          "प्रॉक्टरिंग अपलोड प्रयास {{attempt}} विफल, पुनः प्रयास जारी...",
        drainedQueuedViolation:
          "कतार से उल्लंघन अपलोड हुआ: {{violationType}} (शेष {{remaining}})",
        queueDrainFailed: "कतार निकासी विफल, अगले चक्र में पुनः प्रयास होगा:",
        cocoLoadFailed: "COCO-SSD लोड विफल:",
        faceProcessingError: "चेहरा प्रोसेसिंग त्रुटि:",
        errorProcessingFrame: "फ्रेम प्रोसेसिंग त्रुटि:",
        faceMeshInitError: "Face Mesh प्रारंभ त्रुटि:"
      }
    }
  }
} as const;

export default hi;
